<template>
  <div class="wrapper border-bottom white-bg page-heading">
    <div class="container">
      <div class="row">
        <div class="col-xs-12">
          <heading-loading v-if="loading"></heading-loading>
          <h1 v-else>
            <div v-if="editingUser">
              <i class="far fa-user-circle m-r-sm"></i> {{ accountUser.profile.full_name }}
            </div>
            <div v-else>
              <i class="far fa-user-circle m-r-sm"></i> Create Account User
            </div>
          </h1>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { has } from 'lodash'
  import { mapMutations, mapState } from 'vuex'
  import { RESET_ACCOUNT_USER } from 'vx/mutations'
  import { headingLoading } from 'mixins'

  export default {
    mixins: [headingLoading],

    computed: {
      ...mapState('user/accountUsers', ['accountUser']),

      /**
       * Determine if we are editing a user.
       *
       * @return boolean
       */
      editingUser () {
        return has(this.$route.params, 'childId')
      }
    },

    methods: {
      ...mapMutations('user/accountUsers', [RESET_ACCOUNT_USER])
    }
  }
</script>



// WEBPACK FOOTER //
// AccountUserHeading.vue?f3798e6a